module.exports = __webpack_public_path__ + "static/tulsa-2.81146c74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/tulsa-2.jpg
// module id = 498
// module chunks = 155329947031394